// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ft","header":"fu","subHeader":"fv","button":"fw","actionLinks":"fx","actionLink":"fy","actionText":"fz"};